// extracted by mini-css-extract-plugin
export default {"printRoot":"Print_printRoot__19PpL","receiptPage":"Print_receiptPage__LGRgt","line":"Print_line__WLeZI"};